import React from 'react';
import SEO from '../components/common/SEO';
import Layout from '../components/layout/Layout';
import Section from '../components/common/Section';
import Pricing from '../components/home/Pricing';
import CTA from '../components/home/CTA';
import { siteConfig } from '../config/site';

const PricingPage: React.FC = () => (
  <Layout>
    <SEO
      title={`Pricing | ${siteConfig.brand.name}`}
      description={`Choose the ${siteConfig.brand.name} license that fits your needs — from a one-time demo to enterprise-grade daily flashing allowances.`}
      keywords="flash USDT pricing, USDT flashing software price, buy flash USDT license"
    />
    <Section
      title="Pricing plans"
      subtitle={`Pick the ${siteConfig.brand.name} license that fits how you'll use the software.`}
      background="light"
      padding="large"
      isMainTitle={true}
    >
      <div />
    </Section>
    <Pricing />
    <CTA />
  </Layout>
);

export default PricingPage;
